/* Clog — "officina": animazione del blocco aziende della home (sections/clog-aziende.liquid).
   Parte da sola quando il blocco e' quasi tutto sullo schermo, una volta per ogni arrivo (si ferma se esci, riparte da capo se torni dopo la fine).
   Linea del tempo (ms): 0 schizzo -> 3000 CAD (estrusione) -> 7200 stampa -> ~15800 montaggio nella macchina -> ~19400 il motore parte.
   Stampa: niente guide, la testina si muove libera. Ogni strato: prima il contorno (esterno e foro), poi il riempimento a righe avanti e indietro;
   il materiale compare dove passa l'ugello. Il primo strato e' lento e ravvicinato, poi si accelera come in un time-lapse.
   Montaggio: piccola macchina (motore -> pignone z10 -> ingranaggio z24 -> [pezzo stampato z12] -> ingranaggio z18 con puleggia di uscita).
   3D con three.js r128 (lo stesso caricato dall'apertura; se manca lo carichiamo noi). Misure in "unita'": ingranaggio stampato Ø 140 = 28 mm.
   Senza WebGL o con "riduci movimento" non parte nulla e resta l'illustrazione ferma. */
(function () {
  if (window.ClogOfficina) return;
  window.ClogOfficina = true;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v)), lerp = (a, b, t) => a + (b - a) * t;
  const seg = (t, a, b) => clamp((t - a) / (b - a), 0, 1);
  const ease = t => (t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2), easeOut = t => 1 - Math.pow(1 - t, 3);
  const TAU = Math.PI * 2;

  /* ---------- linea del tempo ---------- */
  const DUR = [4000, 800, 550, 450, 380, 340, 320, 300];      // durata di ogni strato (il primo lento, poi time-lapse)
  const STRATI = DUR.length, H = 16, hS = H / STRATI;         // spessore del pezzo: 16 unita' = 8 mm
  const T = { cad: 3000, stampa: 7200 };
  const P0 = T.stampa + 1000, INIZIO = [];                    // inizio di ogni strato
  DUR.reduce((acc, d, i) => { INIZIO[i] = acc; return acc + d; }, P0);
  const P1 = P0 + DUR.reduce((a, b) => a + b, 0);             // fine stampa
  T.mont = P1 + 450; T.fine = T.mont + 3200;
  const QUOTA_BORDO = .42;                                    // parte di ogni strato spesa sul contorno
  const THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';

  /* ---------- geometria degli ingranaggi (stessi profili di gen/gear.js) ---------- */
  function contorno(z, r, m, passo) {
    const ra = r + m, rf = r - 1.25 * m, a = TAU / z, pts = [];
    const arco = (R, t0, t1) => { const n = Math.max(1, Math.ceil(Math.abs(t1 - t0) / (Math.PI / 180 * passo)));
      for (let k = 0; k <= n; k++) { const t = t0 + (t1 - t0) * k / n; pts.push([R * Math.cos(t), R * Math.sin(t)]); } };
    for (let i = 0; i < z; i++) { const c = i * a; arco(rf, c - a / 2, c - a * .27); arco(ra, c - a * .15, c + a * .15); arco(rf, c + a * .27, c + a / 2); }
    return pts;
  }
  const cerchio = (cx, cy, R, n = 40) => Array.from({ length: n }, (_, k) => { const t = k / n * TAU; return [cx + R * Math.cos(t), cy + R * Math.sin(t)]; });
  function forma(THREE, pts, fori) {
    const s = new THREE.Shape(pts.map(p => new THREE.Vector2(p[0], p[1])));
    fori.forEach(f => s.holes.push(new THREE.Path(f.map(p => new THREE.Vector2(p[0], p[1])))));
    return s;
  }
  // foro con chiavetta (verso +y, che nella vista dall'alto e' in alto come nello schizzo)
  const foroChiavetta = () => Array.from({ length: 60 }, (_, k) => { const t = k / 60 * TAU;
    const d = Math.abs(Math.atan2(Math.sin(t - Math.PI / 2), Math.cos(t - Math.PI / 2))); const R = d < .27 ? 21 : 15;
    return [R * Math.cos(t), R * Math.sin(t)]; });
  // percorso a velocita' costante lungo uno o piu' contorni chiusi
  function percorso(anelli) {
    const pts = []; let L = 0;
    anelli.forEach(an => an.concat([an[0]]).forEach((p, i, arr) => { if (i) L += Math.hypot(p[0] - arr[i - 1][0], p[1] - arr[i - 1][1]); pts.push({ x: p[0], y: p[1], s: L }); }));
    pts.forEach(p => { p.s /= L; });
    const at = s => { let i = 1; while (i < pts.length - 1 && pts[i].s < s) i++; const a = pts[i - 1], b = pts[i], k = clamp((s - a.s) / Math.max(1e-9, b.s - a.s), 0, 1); return [lerp(a.x, b.x, k), lerp(a.y, b.y, k)]; };
    return { pts, at };
  }

  /* ---------- texture del piano di stampa ---------- */
  function texPiano(THREE) {
    const c = document.createElement('canvas'); c.width = c.height = 512; const g = c.getContext('2d');
    g.fillStyle = '#2a2927'; g.fillRect(0, 0, 512, 512);
    for (let i = 0; i < 9000; i++) { g.fillStyle = `rgba(255,255,255,${Math.random() * .045})`; g.fillRect(Math.random() * 512, Math.random() * 512, 1.4, 1.4); }
    g.strokeStyle = 'rgba(255,255,255,.07)'; g.lineWidth = 1;
    for (let x = 32; x < 512; x += 64) { g.beginPath(); g.moveTo(x, 0); g.lineTo(x, 512); g.stroke(); g.beginPath(); g.moveTo(0, x); g.lineTo(512, x); g.stroke(); }
    g.strokeStyle = 'rgba(255,255,255,.18)'; g.lineWidth = 3; g.strokeRect(10, 10, 492, 492);
    g.fillStyle = 'rgba(255,255,255,.16)'; g.font = 'bold 40px system-ui, sans-serif'; g.fillText('clog', 400, 482);
    const t = new THREE.CanvasTexture(c); t.anisotropy = 4; return t;
  }

  /* ---------- testina della stampante, libera (origine = punta dell'ugello) ---------- */
  function testina(THREE) {
    const g = new THREE.Group();
    const ottone = new THREE.MeshStandardMaterial({ color: 0xc89b45, metalness: .85, roughness: .3 });
    const allu = new THREE.MeshStandardMaterial({ color: 0xc4c8cc, metalness: .7, roughness: .35 });
    const scuro = new THREE.MeshStandardMaterial({ color: 0x1f1f1e, metalness: .2, roughness: .55 });
    const ugello = new THREE.Mesh(new THREE.ConeGeometry(4.2, 7, 6), ottone); ugello.rotation.x = Math.PI; ugello.position.y = 3.5; g.add(ugello);
    const dado = new THREE.Mesh(new THREE.CylinderGeometry(5.6, 5.6, 3.4, 6), ottone); dado.position.y = 8.6; g.add(dado);
    const blocco = new THREE.Mesh(new THREE.BoxGeometry(20, 10, 15), allu); blocco.position.set(2, 15, 0); g.add(blocco);
    const gola = new THREE.Mesh(new THREE.CylinderGeometry(2.4, 2.4, 8, 12), allu); gola.position.y = 24; g.add(gola);
    for (let i = 0; i < 6; i++) { const al = new THREE.Mesh(new THREE.CylinderGeometry(9, 9, 1.3, 24), allu); al.position.y = 29 + i * 3; g.add(al); }
    const guscio = new THREE.Mesh(new THREE.BoxGeometry(46, 42, 40), scuro); guscio.position.set(0, 66, 0); g.add(guscio);
    const fascia = new THREE.Mesh(new THREE.BoxGeometry(46.4, 5, 40.4), new THREE.MeshStandardMaterial({ color: 0xb15533, roughness: .5 })); fascia.position.set(0, 50, 0); g.add(fascia);
    const ventola = new THREE.Mesh(new THREE.CylinderGeometry(13, 13, 1.5, 32), new THREE.MeshStandardMaterial({ color: 0x0f0f0f, roughness: .8 }));
    ventola.rotation.x = Math.PI / 2; ventola.position.set(0, 68, 20.6); g.add(ventola);
    const mozzo = new THREE.Mesh(new THREE.CylinderGeometry(4, 4, 2, 16), allu); mozzo.rotation.x = Math.PI / 2; mozzo.position.set(0, 68, 21.4); g.add(mozzo);
    const punta = new THREE.Mesh(new THREE.SphereGeometry(1.6, 12, 8), new THREE.MeshBasicMaterial({ color: 0xff9a55 })); punta.position.y = -.4; g.add(punta);
    g.userData.punta = punta;
    g.scale.setScalar(.72);
    return g;
  }

  /* ---------- materiali che si possono dissolvere ---------- */
  function trasparenza(obj, o) {
    obj.visible = o > .002;
    obj.traverse(n => { const ms = n.material ? (Array.isArray(n.material) ? n.material : [n.material]) : [];
      ms.forEach(m => { if (m.userData.op0 === undefined) m.userData.op0 = m.opacity; m.transparent = o < .999 || m.userData.op0 < 1; m.opacity = m.userData.op0 * o; m.depthWrite = o > .5; }); });
  }

  /* ---------- costruzione della scena ---------- */
  function costruisci(sec, THREE) {
    const stage = sec.querySelector('[data-stage-caz]'), box3d = sec.querySelector('.caz__3d');
    let renderer;
    try { renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true }); } catch (e) { return null; }
    if (!renderer.getContext()) return null;
    const telefono = window.innerWidth < 750;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, telefono ? 1.75 : 2));
    renderer.setClearColor(0x000000, 0);
    renderer.shadowMap.enabled = !telefono; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    box3d.appendChild(renderer.domElement);

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(30, 6 / 5, 10, 6000);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x3a3836, .55));
    const sole = new THREE.DirectionalLight(0xffffff, .95); sole.position.set(260, 520, 320);
    sole.castShadow = !telefono; sole.shadow.mapSize.set(1024, 1024);
    Object.assign(sole.shadow.camera, { left: -440, right: 440, top: 440, bottom: -440, near: 50, far: 1600 }); sole.shadow.bias = -.0008;
    scene.add(sole, sole.target);
    const calda = new THREE.PointLight(0xff8a4a, 0, 120, 2); scene.add(calda);
    const piatto = g => { g.rotateX(-Math.PI / 2); return g; };   // forma nel piano XY -> appoggiata, spessore verso l'alto (x, y) -> (x, z=-y)

    // profilo del pezzo
    const p1 = contorno(12, 60, 10, 3), f1 = foroChiavetta();
    const s1 = forma(THREE, p1, [f1]);

    // --- CAD: griglia, profilo, pezzo estruso con spigoli
    const griglia = new THREE.GridHelper(700, 35, 0x8f9aa6, 0xb9c1ca); griglia.position.y = -.2; scene.add(griglia);
    const linee = new THREE.LineBasicMaterial({ color: 0x1d3c63, transparent: true });
    const profilo = new THREE.Group();
    [p1, f1].forEach(pp => { const l = new THREE.LineLoop(new THREE.BufferGeometry().setFromPoints(pp.map(p => new THREE.Vector3(p[0], p[1], 0))), linee); profilo.add(l); });
    profilo.rotation.x = -Math.PI / 2; profilo.position.y = .3; scene.add(profilo);
    const cadGeo = piatto(new THREE.ExtrudeGeometry(s1, { depth: H, bevelEnabled: true, bevelThickness: .7, bevelSize: .7, bevelSegments: 2 }));
    const cad = new THREE.Mesh(cadGeo, new THREE.MeshStandardMaterial({ color: 0xb7bfc8, metalness: .3, roughness: .42 }));
    cad.add(new THREE.LineSegments(new THREE.EdgesGeometry(cadGeo, 25), new THREE.LineBasicMaterial({ color: 0x24303c, transparent: true, opacity: .6 })));
    const cadBox = new THREE.Group(); cadBox.add(cad); scene.add(cadBox);

    // --- stampa: piano, strati, contorno che si deposita, testina libera
    const pianoMesh = new THREE.Mesh(new THREE.BoxGeometry(330, 6, 330), [
      new THREE.MeshStandardMaterial({ color: 0x1d1c1b, roughness: .6 }), new THREE.MeshStandardMaterial({ color: 0x1d1c1b, roughness: .6 }),
      new THREE.MeshStandardMaterial({ map: texPiano(THREE), roughness: .85 }), new THREE.MeshStandardMaterial({ color: 0x1d1c1b, roughness: .6 }),
      new THREE.MeshStandardMaterial({ color: 0x1d1c1b, roughness: .6 }), new THREE.MeshStandardMaterial({ color: 0x1d1c1b, roughness: .6 })]);
    pianoMesh.position.y = -3.01; pianoMesh.receiveShadow = true; scene.add(pianoMesh);
    const stratoGeo = piatto(new THREE.ExtrudeGeometry(s1, { depth: hS, bevelEnabled: false }));
    const mA = new THREE.MeshStandardMaterial({ color: 0x9c4628, roughness: .72 }), mB = new THREE.MeshStandardMaterial({ color: 0x883c22, roughness: .78 });
    // riempimento dello strato in corso: compare riga per riga, fin dove e' arrivato l'ugello
    const PASSO = 9, YMIN = -70, RIGHE = Math.ceil(140 / PASSO);
    const U = { riga: { value: -1 }, x: { value: 0 }, dir: { value: 1 }, ymin: { value: YMIN }, passo: { value: PASSO }, s: { value: 0 } };
    const mOra = new THREE.MeshStandardMaterial({ color: 0xab5130, roughness: .6, emissive: 0x2a0d04 });
    mOra.onBeforeCompile = sh => {
      Object.assign(sh.uniforms, { uRiga: U.riga, uX: U.x, uDir: U.dir, uYmin: U.ymin, uPasso: U.passo });
      sh.vertexShader = 'varying vec2 vPL;\n' + sh.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>\n vPL = vec2(position.x, -position.z);');
      sh.fragmentShader = 'uniform float uRiga, uX, uDir, uYmin, uPasso;\nvarying vec2 vPL;\n' + sh.fragmentShader.replace('#include <clipping_planes_fragment>',
        'float rL = floor((vPL.y - uYmin) / uPasso); if (rL > uRiga + .5) discard; if (abs(rL - uRiga) < .5 && (uDir > 0. ? vPL.x > uX : vPL.x < uX)) discard;\n#include <clipping_planes_fragment>');
    };
    const pezzo = new THREE.Group(); const strati = [];
    for (let k = 0; k < STRATI; k++) { const m = new THREE.Mesh(stratoGeo, k % 2 ? mB : mA); m.position.y = k * hS; m.castShadow = true; m.receiveShadow = true; pezzo.add(m); strati.push(m); }
    // contorno (esterno + foro) che si deposita mentre passa l'ugello: nastro con la sua parete esterna
    const bordo = percorso([p1, f1]);
    const nastro = (() => {
      const pos = [], sAttr = [], idx = [], W = 3.2;
      const anelli = [p1, f1];
      let base = 0, off = 0;
      anelli.forEach((an, ai) => {
        const n = an.length, verso = ai === 0 ? 1 : -1;     // esterno: verso l'interno; foro: verso il materiale (fuori dal foro)
        const sLoc = bordo.pts.slice(off, off + n + 1).map(p => p.s); off += n + 1;
        for (let i = 0; i <= n; i++) {
          const p = an[i % n], a = an[(i - 1 + n) % n], b = an[(i + 1) % n];
          let nx = -(b[1] - a[1]), ny = b[0] - a[0]; const l = Math.hypot(nx, ny) || 1; nx = nx / l * verso; ny = ny / l * verso;
          const s = sLoc[i];
          // in alto: bordo e interno del nastro; in basso: piede della parete
          pos.push(p[0], hS + .05, -p[1], p[0] + nx * W, hS + .05, -(p[1] + ny * W), p[0], 0, -p[1]);
          sAttr.push(s, s, s);
          if (i) { const v = base + i * 3, u = v - 3; idx.push(u, v, u + 1, v, v + 1, u + 1, u + 2, v + 2, u, v + 2, v, u); }
        }
        base += (n + 1) * 3;
      });
      const g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3)); g.setAttribute('aS', new THREE.Float32BufferAttribute(sAttr, 1)); g.setIndex(idx); g.computeVertexNormals();
      const m = new THREE.MeshStandardMaterial({ color: 0xc0602f, roughness: .55, emissive: 0x3a1206, side: THREE.DoubleSide });
      m.onBeforeCompile = sh => {
        sh.uniforms.uS = U.s;
        sh.vertexShader = 'attribute float aS;\nvarying float vS;\n' + sh.vertexShader.replace('#include <begin_vertex>', '#include <begin_vertex>\n vS = aS;');
        sh.fragmentShader = 'uniform float uS;\nvarying float vS;\n' + sh.fragmentShader.replace('#include <clipping_planes_fragment>', 'if (vS > uS) discard;\n#include <clipping_planes_fragment>');
      };
      const mesh = new THREE.Mesh(g, m); mesh.castShadow = true; return mesh;
    })();
    pezzo.add(nastro);
    const pezzoBox = new THREE.Group(); pezzoBox.add(pezzo); scene.add(pezzoBox);
    // righe del riempimento: dove taglia il contorno esterno
    const righe = Array.from({ length: RIGHE }, (_, r) => {
      const y = YMIN + (r + .5) * PASSO, xs = [];
      for (let i = 0; i < p1.length; i++) { const a = p1[i], b = p1[(i + 1) % p1.length];
        if ((a[1] - y) * (b[1] - y) <= 0 && a[1] !== b[1]) xs.push(a[0] + (y - a[1]) / (b[1] - a[1]) * (b[0] - a[0])); }
      const x0 = xs.length ? Math.min(...xs) + 2 : 0, x1 = xs.length ? Math.max(...xs) - 2 : 0;
      return { y, x0, x1, w: Math.max(1, x1 - x0) };
    });
    const totRighe = righe.reduce((a, r) => a + r.w, 0);
    const testa = testina(THREE); testa.traverse(n => { if (n.isMesh) n.castShadow = true; }); scene.add(testa);

    // --- montaggio: la macchina (motore -> pignone -> ingranaggio grande -> pezzo stampato -> ingranaggio d'uscita con puleggia)
    const YG = 50;                                              // quota degli ingranaggi
    const mac = new THREE.Group();
    const metallo = new THREE.MeshStandardMaterial({ color: 0x4a4740, metalness: .25, roughness: .6 });
    const scuroM = new THREE.MeshStandardMaterial({ color: 0x2b2a27, metalness: .3, roughness: .55 });
    const acciaio = new THREE.MeshStandardMaterial({ color: 0xc9ccd0, metalness: .35, roughness: .3 });
    const ottoneM = new THREE.MeshStandardMaterial({ color: 0xb08d4a, metalness: .5, roughness: .35 });
    const ingr = (z, fori, mat) => { const r = z * 5; const sh = forma(THREE, contorno(z, r, 10, 3), fori);
      const m = new THREE.Mesh(piatto(new THREE.ExtrudeGeometry(sh, { depth: H, bevelEnabled: true, bevelThickness: .6, bevelSize: .6, bevelSegments: 1 })), mat);
      m.castShadow = m.receiveShadow = true; return m; };
    // posizioni lungo la catena (angolo nel piano: atan2(-z, x), come la rotazione dei pezzi)
    const dirz = a => [Math.cos(a), -Math.sin(a)];
    const C = { P: [-250, 60] };
    C.G1 = [C.P[0] + 170 * dirz(0)[0], C.P[1] + 170 * dirz(0)[1]];
    C.X = [C.G1[0] + 180 * dirz(40 * Math.PI / 180)[0], C.G1[1] + 180 * dirz(40 * Math.PI / 180)[1]];
    C.G3 = [C.X[0] + 150 * dirz(-30 * Math.PI / 180)[0], C.X[1] + 150 * dirz(-30 * Math.PI / 180)[1]];
    const Z = { P: 10, G1: 24, X: 12, G3: 18 };
    // centro la macchina sull'origine
    const bx = [C.P[0] - 60, C.G1[0] - 130, C.G3[0] + 100], bz = [C.G1[1] + 130, C.X[1] - 70, C.G3[1] - 100, C.G1[1] - 130];
    const cx = (Math.min(...bx) + Math.max(...bx)) / 2, cz = (Math.min(...bz) + Math.max(...bz)) / 2;
    Object.keys(C).forEach(k => { C[k] = [C[k][0] - cx, C[k][1] - cz]; });
    const W = Math.max(...bx) - Math.min(...bx) + 90, D = Math.max(...bz) - Math.min(...bz) + 90;
    // fase dei denti: ogni coppia ingrana (dente contro vano)
    const ang = (a, b) => Math.atan2(-(C[b][1] - C[a][1]), C[b][0] - C[a][0]);
    const fase = (a, fa, b) => { const al = ang(a, b), pa = TAU / Z[a], pb = TAU / Z[b];
      const ua = (((al - fa) / pa) % 1 + 1) % 1; return al + Math.PI - (.5 - ua) * pb; };
    const F = { X: 0 }; F.G1 = fase('X', 0, 'G1'); F.G3 = fase('X', 0, 'G3'); F.P = fase('G1', F.G1, 'P');
    const OM = { X: 1, G1: -Z.X / Z.G1, G3: -Z.X / Z.G3, P: Z.X / Z.P };   // velocita' rispetto al pezzo stampato
    // base, telaio, viti
    const base = new THREE.Mesh(new THREE.BoxGeometry(W, 14, D), metallo); base.position.y = -7; base.receiveShadow = true; mac.add(base);
    [[0, -D / 2 + 5, W, 10], [0, D / 2 - 5, W, 10]].forEach(b => { const r = new THREE.Mesh(new THREE.BoxGeometry(b[2], 22, b[3]), scuroM); r.position.set(b[0], 11, b[1]); r.castShadow = r.receiveShadow = true; mac.add(r); });
    [[-1, -1], [1, -1], [-1, 1], [1, 1]].forEach(s => { const v = new THREE.Mesh(new THREE.CylinderGeometry(7, 7, 4, 6), acciaio); v.position.set(s[0] * (W / 2 - 22), 2, s[1] * (D / 2 - 26)); mac.add(v); });
    // supporti, alberi e ingranaggi
    const ruote = {};
    const supporto = (k, rAlb) => { const [x, z] = C[k];
      const blocco = new THREE.Mesh(new THREE.BoxGeometry(64, YG - 4, 44), scuroM); blocco.position.set(x, (YG - 4) / 2, z); blocco.castShadow = blocco.receiveShadow = true; mac.add(blocco);
      [-24, 24].forEach(dx => { const v = new THREE.Mesh(new THREE.CylinderGeometry(4.5, 4.5, 3, 6), acciaio); v.position.set(x + dx, YG - 2.5, z + 12); mac.add(v); });
      const alb = new THREE.Mesh(new THREE.CylinderGeometry(rAlb, rAlb, 40, 24), acciaio); alb.position.set(x, YG + 14, z); alb.castShadow = true; mac.add(alb); };
    const holder = (k, mesh) => { const g = new THREE.Group(); g.position.set(C[k][0], YG, C[k][1]); if (mesh) g.add(mesh); mac.add(g); ruote[k] = g; return g; };
    supporto('G1', 14); holder('G1', ingr(24, [cerchio(0, 0, 15)].concat([0, 1, 2, 3, 4, 5].map(k => { const t = k * TAU / 6; return cerchio(78 * Math.cos(t), 78 * Math.sin(t), 22, 30); })), new THREE.MeshStandardMaterial({ color: 0x8f8c86, metalness: .3, roughness: .4 })));
    supporto('G3', 17); holder('G3', ingr(18, [cerchio(0, 0, 18)].concat([0, 1, 2, 3, 4].map(k => { const t = k * TAU / 5 - Math.PI / 2; return cerchio(50 * Math.cos(t), 50 * Math.sin(t), 16, 28); })), new THREE.MeshStandardMaterial({ color: 0x6e6a63, metalness: .35, roughness: .4 })));
    supporto('X', 14);                                          // il posto vuoto: albero pronto per il pezzo
    // puleggia di uscita sopra l'ingranaggio d'uscita (gira con lui)
    const puleggia = new THREE.Group();
    const cerch = new THREE.Mesh(new THREE.TorusGeometry(46, 6, 12, 48), acciaio); cerch.rotation.x = Math.PI / 2; puleggia.add(cerch);
    const mozzoP = new THREE.Mesh(new THREE.CylinderGeometry(12, 12, 14, 24), acciaio); puleggia.add(mozzoP);
    for (let i = 0; i < 6; i++) { const r = new THREE.Mesh(new THREE.BoxGeometry(40, 5, 6), acciaio); const a = i * TAU / 6; r.position.set(Math.cos(a) * 24, 0, -Math.sin(a) * 24); r.rotation.y = a; puleggia.add(r); }
    const albP = new THREE.Mesh(new THREE.CylinderGeometry(9, 9, 70, 20), acciaio); albP.position.y = -26; puleggia.add(albP);
    puleggia.position.y = H + 50; puleggia.traverse(n => { if (n.isMesh) n.castShadow = true; }); ruote.G3.add(puleggia);
    // motore con pignone
    const [mx, mz] = C.P;
    const motore = new THREE.Group(); motore.position.set(mx, 0, mz); mac.add(motore);
    const corpo = new THREE.Mesh(new THREE.CylinderGeometry(44, 44, YG - 6, 40), scuroM); corpo.position.y = (YG - 6) / 2; corpo.castShadow = true; motore.add(corpo);
    for (let i = 0; i < 5; i++) { const al = new THREE.Mesh(new THREE.CylinderGeometry(45.5, 45.5, 2, 40), metallo); al.position.y = 6 + i * 7; motore.add(al); }
    const fasciaM = new THREE.Mesh(new THREE.CylinderGeometry(44.6, 44.6, 6, 40), new THREE.MeshStandardMaterial({ color: 0xb15533, roughness: .5 })); fasciaM.position.y = YG - 12; motore.add(fasciaM);
    const coperchio = new THREE.Mesh(new THREE.CylinderGeometry(38, 44, 6, 40), metallo); coperchio.position.y = YG - 3; motore.add(coperchio);
    const spia = new THREE.Mesh(new THREE.SphereGeometry(4, 12, 8), new THREE.MeshBasicMaterial({ color: 0xd23b2b })); spia.position.set(30, YG - 3, 26); motore.add(spia);
    const cavo = new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3([new THREE.Vector3(-40, 10, 10), new THREE.Vector3(-70, 4, 40), new THREE.Vector3(-90, 2, 90), new THREE.Vector3(-W / 2 - mx + 30, 2, D / 2 - mz - 20)]), 30, 4, 8), new THREE.MeshStandardMaterial({ color: 0x151514, roughness: .7 }));
    cavo.castShadow = true; motore.add(cavo);
    holder('P', ingr(10, [cerchio(0, 0, 8)], ottoneM));
    scene.add(mac);
    const DEST = [C.X[0], YG, C.X[1]];                          // dove va il pezzo stampato

    /* ---------- elementi HTML ---------- */
    const $ = s => sec.querySelector(s);
    const ui = { carta: $('.caz__carta'), sk: $('.caz__sk'), skp: [...sec.querySelectorAll('.caz__sk path')], cadBg: $('.caz__bg--cad'), cui: $('.cui'),
      val: $('.cui__val'), cubo: $('.cui__cubo'), hud: $('.chud'), hl: $('.chud__l'), ht: $('.chud__t'), hp: $('.chud__p'), rivedi: $('.caz__rivedi') };
    ui.skp.forEach(p => { p.style.strokeDasharray = '1 1'; });
    const passi = [...sec.querySelectorAll('.caz__step')], punti = [...sec.querySelectorAll('.caz__dots i')];
    stage.classList.add('is-3d'); sec.classList.add('caz--anim');

    /* ---------- telecamera ---------- */
    const V = { alto: [405, 89.6, 0, 0, 0, 0], iso: [470, 30, 38, 8, 0, 0], vicino: [250, 40, 26, 6, 0, 0], stampa: [430, 30, 30, 12, 0, 0], mont: [1260, 42, 18, 10, 0, 30] };
    const mix = (a, b, k) => a.map((v, i) => lerp(v, b[i], k));
    function vista(t) {
      let v = V.alto;
      v = mix(v, V.iso, ease(seg(t, T.cad + 900, T.cad + 3400)));
      v = mix(v, V.vicino, ease(seg(t, T.stampa, P0 + 300)));
      v = mix(v, V.stampa, ease(seg(t, INIZIO[1] - 600, INIZIO[2] + 300)));
      v = mix(v, V.mont, ease(seg(t, T.mont, T.mont + 2200)));
      const [R, el, az, ty, tx, tz] = v, e = el * Math.PI / 180, a = az * Math.PI / 180;
      camera.position.set(tx + R * Math.cos(e) * Math.sin(a), ty + R * Math.sin(e), tz + R * Math.cos(e) * Math.cos(a));
      camera.lookAt(tx, ty, tz);
      if (ui.cubo) ui.cubo.style.transform = `rotateX(${(-el).toFixed(1)}deg) rotateY(${(-az).toFixed(1)}deg)`;
    }

    /* ---------- un fotogramma della linea del tempo ---------- */
    let angolo = 0, ultimoPasso = -1;
    function scena(t, dt) {
      // 1. schizzo
      const via = 1 - seg(t, T.cad, T.cad + 600);
      ui.carta.setAttribute('opacity', via.toFixed(3));
      ui.sk.setAttribute('opacity', (seg(t, 0, 200) * via).toFixed(3));
      ui.skp.forEach((p, i) => { p.style.strokeDashoffset = (1 - seg(t, 250 + i * 260, 2300 + i * 160)).toFixed(4); });
      // 2. CAD
      const cadOn = seg(t, T.cad + 100, T.cad + 600) * (1 - seg(t, T.stampa, T.stampa + 500));
      ui.cadBg.style.opacity = cadOn.toFixed(3); ui.cui.style.opacity = cadOn.toFixed(3);
      trasparenza(griglia, cadOn); linee.opacity = seg(t, T.cad + 200, T.cad + 700) * (1 - seg(t, T.stampa, T.stampa + 400));
      profilo.visible = linee.opacity > .01;
      const est = ease(seg(t, T.cad + 1100, T.cad + 2500));
      cad.scale.y = Math.max(.001, est);
      trasparenza(cadBox, (est > .002 ? 1 : 0) * (1 - seg(t, T.stampa + 300, T.stampa + 900)));
      ui.cui.classList.toggle('is-dlg', t > T.cad + 700 && t < T.cad + 2950);
      ui.cui.classList.toggle('is-estrudi', t > T.cad + 500 && t < T.cad + 2950);
      ui.cui.classList.toggle('is-ok', t > T.cad + 2650 && t < T.cad + 2950);
      ui.cui.classList.toggle('is-corpo', t > T.cad + 2900);
      ui.val.textContent = (est * 8).toFixed(2) + ' mm';
      // 3. stampa
      const pianoOn = seg(t, T.stampa + 200, T.stampa + 800) * (1 - seg(t, T.mont, T.mont + 600));
      trasparenza(pianoMesh, pianoOn); pianoMesh.position.y = -3.01 - (1 - pianoOn) * 30;
      let k = -1, f = 0;
      if (t >= P0 && t < P1) { k = STRATI - 1; while (k > 0 && t < INIZIO[k]) k--; f = (t - INIZIO[k]) / DUR[k]; }
      const stampato = t >= P1;
      strati.forEach((m, i) => { m.visible = stampato || (k >= 0 && (i < k || (i === k && f > QUOTA_BORDO))); m.material = (!stampato && i === k) ? mOra : (i % 2 ? mB : mA); });
      let nx = 0, ny = 0, yTop = 0;
      if (k >= 0) {
        yTop = (k + 1) * hS;
        if (f <= QUOTA_BORDO) {                                  // contorno: esterno e poi foro
          const s = f / QUOTA_BORDO; [nx, ny] = bordo.at(s); U.s.value = s; U.riga.value = -1;
        } else {                                                 // riempimento a righe alterne
          U.s.value = 1;
          let d = (f - QUOTA_BORDO) / (1 - QUOTA_BORDO) * totRighe, r = 0;
          while (r < righe.length - 1 && d > righe[r].w) { d -= righe[r].w; r++; }
          const R = righe[r], dir = (r + k) % 2 ? -1 : 1, x = dir > 0 ? R.x0 + Math.min(d, R.w) : R.x1 - Math.min(d, R.w);
          nx = x; ny = R.y; U.riga.value = r; U.x.value = x; U.dir.value = dir;
        }
        nastro.visible = true; nastro.position.y = k * hS;
      } else nastro.visible = false;
      if (stampato) [nx, ny] = bordo.at(0);
      const scendi = seg(t, T.stampa + 400, P0), sali = seg(t, P1, T.mont + 300);
      const testaOn = seg(t, T.stampa + 300, T.stampa + 700) * (1 - seg(t, T.mont, T.mont + 300));
      const [sx, sy] = bordo.at(0);
      if (t < P0) testa.position.set(lerp(0, sx, easeOut(scendi)), .2 + (1 - easeOut(scendi)) * 140, lerp(0, -sy, easeOut(scendi)));
      else testa.position.set(nx, (stampato ? H : yTop) + .2 + ease(sali) * 160, -ny);
      trasparenza(testa, testaOn);
      testa.userData.punta.visible = t > P0 && t < P1;
      calda.intensity = (t > P0 && t < P1) ? .8 : 0; calda.position.set(testa.position.x, testa.position.y + 6, testa.position.z);
      const hudOn = seg(t, T.stampa + 600, T.stampa + 900) * (1 - seg(t, T.mont, T.mont + 300));
      ui.hud.style.opacity = hudOn.toFixed(3);
      if (hudOn > 0) { const pr = seg(t, P0, P1); ui.hl.textContent = `${ui.hud.dataset.strato || 'Strato'} ${stampato ? STRATI : Math.max(0, k + 1)}/${STRATI}`; ui.ht.textContent = `${Math.round(215 + Math.sin(t / 170) * 1.2)} °C`; ui.hp.textContent = `${Math.round(pr * 100)}%`; }
      // 4. montaggio nella macchina
      const macOn = ease(seg(t, T.mont + 300, T.mont + 1300));
      trasparenza(mac, macOn); mac.position.y = -(1 - macOn) * 60;
      const su = ease(seg(t, T.mont + 200, T.mont + 900)), va = ease(seg(t, T.mont + 1300, T.mont + 2300)), giu = easeOut(seg(t, T.mont + 2300, T.mont + 2900));
      const yIn = su * 140;
      pezzoBox.position.set(lerp(0, DEST[0], va), lerp(yIn, DEST[1] + mac.position.y, giu), lerp(0, DEST[2], va));
      pezzoBox.rotation.z = Math.sin(va * Math.PI) * .1;
      const acceso = t > T.fine - 200;
      if (acceso) angolo += dt * .0016 * clamp((t - T.fine + 200) / 1200, 0, 1);
      pezzo.rotation.y = F.X + OM.X * angolo;
      ['G1', 'G3', 'P'].forEach(kk => { ruote[kk].rotation.y = F[kk] + OM[kk] * angolo; });
      spia.material.color.setHex(acceso ? 0x3fd06b : 0xd23b2b);
      // telecamera e testi
      vista(t);
      const passo = t < T.cad ? 0 : t < T.stampa ? 1 : t < T.mont ? 2 : 3;
      if (passo !== ultimoPasso) { ultimoPasso = passo; passi.forEach((li, i) => li.classList.toggle('is-on', i === passo)); punti.forEach((d, i) => d.classList.toggle('is-on', i <= passo)); }
    }

    function misura() {
      const w = stage.clientWidth, h = stage.clientHeight; if (!w || !h) return;
      renderer.setSize(w, h, false); camera.aspect = w / h;
      camera.fov = w / h < 1.15 ? 33 : 30; camera.updateProjectionMatrix();
    }
    misura();
    if ('ResizeObserver' in window) new ResizeObserver(misura).observe(stage); else window.addEventListener('resize', misura);

    /* ---------- riproduzione ---------- */
    let t = 0, vai = false, visibile = false, finito = false, last = 0, raf = 0;
    function loop(now) {
      raf = 0;
      const dt = last ? Math.min(60, now - last) : 16; last = now;
      if (vai) t += dt;
      if (t >= T.fine + 600 && !finito) { finito = true; ui.rivedi.hidden = false; }
      scena(t, (vai || finito) ? dt : 0);
      renderer.render(scene, camera);
      if (visibile && (vai || finito)) raf = requestAnimationFrame(loop); else last = 0;
    }
    const avvia = () => { if (!raf) { last = 0; raf = requestAnimationFrame(loop); } };
    const daCapo = () => { t = 0; angolo = 0; finito = false; ui.rivedi.hidden = true; vai = true; avvia(); };
    new IntersectionObserver(es => es.forEach(e => {
      visibile = e.isIntersecting;
      if (e.intersectionRatio >= .5) { if (finito && t === -1) daCapo(); vai = true; avvia(); }
      else if (!e.isIntersecting) { vai = false; if (finito) t = -1; }        // uscito dopo la fine: la prossima volta riparte da capo
      else vai = false;
    }), { threshold: [0, .5] }).observe(stage);
    ui.rivedi.addEventListener('click', daCapo);
    const inizio = [0, T.cad, T.stampa, T.mont];
    passi.forEach((li, i) => li.addEventListener('click', () => { t = inizio[i]; angolo = 0; finito = false; ui.rivedi.hidden = true; vai = true; avvia(); }));
    scena(0, 0); renderer.render(scene, camera);
    sec.clogOfficina = { T, P0, P1, INIZIO, a: ms => { vai = false; t = ms; finito = ms >= T.fine; if (ms > T.fine) angolo = (ms - T.fine) * .0016; scena(t, 0); renderer.render(scene, camera); } };   // per le prove
    return true;
  }

  /* ---------- avvio: prepara il 3D solo quando il blocco si avvicina ---------- */
  function conThree(cb) {
    if (window.THREE) return cb(window.THREE);
    let s = document.querySelector('script[src*="three.min.js"]');
    if (!s) { s = document.createElement('script'); s.src = THREE_URL; s.async = true; document.head.appendChild(s); }
    s.addEventListener('load', () => window.THREE && cb(window.THREE), { once: true });
  }
  function init() {
    if (still || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-caz]').forEach(sec => {
      if (sec.dataset.officina) return; sec.dataset.officina = '1';
      const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); conThree(THREE => { try { costruisci(sec, THREE); } catch (e) { console.warn('clog officina', e); } }); } }, { rootMargin: '400px 0px' });
      io.observe(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
